/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import OrdersCheckoutserviceproductPostRequestServiceItemsInner from './OrdersCheckoutserviceproductPostRequestServiceItemsInner';

/**
 * The OrdersCheckoutserviceproductPostRequest model module.
 * @module model/OrdersCheckoutserviceproductPostRequest
 * @version 1.0.0
 */
class OrdersCheckoutserviceproductPostRequest {
    /**
     * Constructs a new <code>OrdersCheckoutserviceproductPostRequest</code>.
     * @alias module:model/OrdersCheckoutserviceproductPostRequest
     */
    constructor() { 
        
        OrdersCheckoutserviceproductPostRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OrdersCheckoutserviceproductPostRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrdersCheckoutserviceproductPostRequest} obj Optional instance to populate.
     * @return {module:model/OrdersCheckoutserviceproductPostRequest} The populated <code>OrdersCheckoutserviceproductPostRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrdersCheckoutserviceproductPostRequest();

            if (data.hasOwnProperty('channel')) {
                obj['channel'] = ApiClient.convertToType(data['channel'], 'String');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
            if (data.hasOwnProperty('customerId')) {
                obj['customerId'] = ApiClient.convertToType(data['customerId'], 'Number');
            }
            if (data.hasOwnProperty('serviceItems')) {
                obj['serviceItems'] = ApiClient.convertToType(data['serviceItems'], [OrdersCheckoutserviceproductPostRequestServiceItemsInner]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>OrdersCheckoutserviceproductPostRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>OrdersCheckoutserviceproductPostRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['channel'] && !(typeof data['channel'] === 'string' || data['channel'] instanceof String)) {
            throw new Error("Expected the field `channel` to be a primitive type in the JSON string but got " + data['channel']);
        }
        if (data['serviceItems']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['serviceItems'])) {
                throw new Error("Expected the field `serviceItems` to be an array in the JSON data but got " + data['serviceItems']);
            }
            // validate the optional field `serviceItems` (array)
            for (const item of data['serviceItems']) {
                OrdersCheckoutserviceproductPostRequestServiceItemsInner.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * Source of request
 * @member {String} channel
 */
OrdersCheckoutserviceproductPostRequest.prototype['channel'] = undefined;

/**
 * The SSB User ID associated with the order
 * @member {Number} userId
 */
OrdersCheckoutserviceproductPostRequest.prototype['userId'] = undefined;

/**
 * The SSB Customer ID associated with the order
 * @member {Number} customerId
 */
OrdersCheckoutserviceproductPostRequest.prototype['customerId'] = undefined;

/**
 * Array of Service Level Basket Items
 * @member {Array.<module:model/OrdersCheckoutserviceproductPostRequestServiceItemsInner>} serviceItems
 */
OrdersCheckoutserviceproductPostRequest.prototype['serviceItems'] = undefined;






export default OrdersCheckoutserviceproductPostRequest;

